import * as Yup from 'yup'

export const InviteWorkersViaCSVSchema = Yup.object().shape({
  collectDataTemplateId: Yup.string().required('Please choose an option'),
  partnerMarketId: Yup.string().required('Please choose an option'),
})
